<template>
  <v-app id="app">
    <v-navigation-drawer
      v-if="
        !$store.state.skipLogin &&
          $router.currentRoute.name != 'login' &&
          $router.currentRoute.name != 'Verify Email' &&
          $store.getters.user &&
          $store.getters.navbar
      "
      v-model="drawer"
      width="270"
      app
    >
      <v-row class="pa-8 pr-4 flex justify-space-between secondary--text">
        <div>
          <h4 class="font-weight-regular">Hello!</h4>
          <h2 class="font-weight-regular">
            {{ $store.getters.user.name.split(" ")[0] }}
          </h2>
        </div>
        <v-btn fab color="primary" @click="$router.push({ name: 'General' })">
          <v-avatar size="50">
            <img :src="previewImage" alt="GoDial" />
          </v-avatar>
        </v-btn>
      </v-row>

      <v-autocomplete
        v-if="
          $store.getters.user.role.toLowerCase() == 'manager' ||
            $store.getters.user.role.toLowerCase() == 'teammanager'
        "
        v-model="selectedTeam"
        :items="teams"
        item-text="name"
        item-value="id"
        label="Teams"
        class="mx-2 primary--text team-selector"
        solo
        background-color="secondary"
        color="primary"
        hide-details
        dense
      >
        <template v-slot:selection="data">
          <span class="text-body-2 text-truncate team-selector-text">
            Team: {{ data.item.name }}
          </span>
        </template>
      </v-autocomplete>

      <v-list solo dense class="my-1">
        <template v-for="item in items">
          <!-- <v-row
            v-if="item.heading"
            :key="item.heading"
            align="center"
            :data-intercom-target="`assignments${item.text}`"
          >
            <v-col cols="6">
              <v-subheader v-if="item.heading">{{ item.heading }}</v-subheader>
            </v-col>
            <v-col cols="6" class="text-center">
              <a href="#!" class="body-2 secondary--text">EDIT</a>
            </v-col>
          </v-row> -->
          <v-list-group
            v-if="item.children && item.visible"
            :key="item.text"
            v-model="item.model"
            class="mx-2"
            :data-intercom-target="`assignments${item.text}`"
            :prepend-icon="item.icon"
            no-action
          >
            <template v-slot:activator>
              <v-list-item class="ml-n4">
                <v-list-item-content>
                  <v-list-item-title
                    class="subtitle-1 secondary--text font-weight-regular d-flex align-center"
                  >
                    <span>{{ item.text }}</span>
                    <v-chip
                      v-if="item.beta"
                      x-small
                      color="primary"
                      class="ml-2 beta-chip"
                      label
                      >BETA</v-chip
                    >
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item
              v-for="(child, i) in item.children"
              :key="i"
              active-class="primarygradMenu white--text rounded "
              link
              :to="child.link"
            >
              <v-list-item-icon v-if="child.icon">
                <v-icon>{{ child.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title
                  class="subtitle-1 secondary--text font-weight-regular"
                  >{{ child.text }}</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

          <v-list-item
            v-else-if="!item.children && item.visible"
            :key="item.text"
            active-class="primarygradMenu white--text mx-2 rounded"
            class="mx-2"
            link
            :to="item.disabled ? '' : item.link"
            :disabled="item.disabled"
            :data-intercom-target="`assignments${item.text}`"
            @click="item.disabled ? showLockedMessage(item.text) : null"
          >
            <v-list-item-action>
              <v-icon :color="item.disabled ? 'grey' : ''">{{
                item.icon
              }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                class="subtitle-1 font-weight-regular d-flex align-center"
                :class="{ 'grey--text': item.disabled }"
              >
                <span>{{ item.text }}</span>
                <v-chip
                  v-if="item.beta"
                  x-small
                  color="primary"
                  class="ml-2 beta-chip"
                  label
                  >BETA</v-chip
                >
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <template>
          <v-list-item
            v-if="$store.state.user.role == 'Manager'"
            active-class="primarygradMenu white--text mx-2 rounded"
            class="mx-2"
            link
            to="/integration"
          >
            <v-list-item-action>
              <v-icon>mdi-account-switch</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="subtitle-1 font-weight-regular">
                Integration
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
        <!-- Inbox -->
        <!-- <template>
          <v-list-item
            v-if="$store.state.user.role == 'Manager'"
            active-class="primarygrad white--text mx-2 rounded"
            class="mx-2"
            link
            to="/inbox"
          >
            <v-list-item-action>
              <v-icon>mdi-message-bulleted</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="subtitle-1 font-weight-regular">
                Inbox
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template> -->

        <template>
          <v-list-item
            v-if="$store.state.user.role == 'Manager'"
            active-class="primarygradMenu white--text mx-2 rounded"
            class="mx-2"
            link
            to="/recording"
          >
            <v-list-item-action>
              <v-icon>mdi-headphones-settings</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title
                class="subtitle-1 font-weight-regular d-flex align-center"
              >
                <span>Recording</span>
                <v-chip x-small color="primary" class="ml-2 beta-chip" label
                  >BETA</v-chip
                >
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template>
          <v-list-item
            active-class="primarygradMenu white--text mx-2 rounded"
            class="mx-2"
            link
            to="/settings"
          >
            <v-list-item-action>
              <v-icon>settings</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="subtitle-1 font-weight-regular">
                Settings
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-if="isMobile()">
          <v-list-item
            active-class="primarygradMenu white--text mx-2 rounded"
            class="mx-2"
            @click="logout"
          >
            <v-list-item-action>
              <v-icon>exit_to_app</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title class="subtitle-1 font-weight-regular">
                Logout
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        <template v-if="!isMobile()">
          <div class="pa-2">
            <v-btn depressed block @click="logout">
              <v-icon class="mr-3">exit_to_app</v-icon>
              Logout
            </v-btn>
          </div>
        </template>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      v-if="
        !$store.state.skipLogin &&
          $router.currentRoute.name != 'login' &&
          $store.getters.user &&
          $store.getters.navbar
      "
      :class="$vuetify.theme.dark ? '' : 'inverted'"
      :color="$vuetify.theme.dark ? 'transparent' : undefined"
      :flat="$vuetify.theme.dark"
      elevate-on-scroll
      app
    >
      <v-btn v-if="SubPage" icon @click="$router.go(-1)">
        <v-icon class="secondary--text">arrow_back</v-icon>
      </v-btn>

      <v-app-bar-nav-icon
        v-else
        class="secondary--text"
        data-intercom-target="navbarmenu"
        @click.stop="drawer = !drawer"
      />

      <v-toolbar-title class="ml-0 pl-4 seconday"
        ><b>{{ routeName() }}</b></v-toolbar-title
      >

      <!-- $router.currentRoute.name -->

      <v-spacer />
      <!-- Help button -->
      <div class="text-center">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="text-cap"
              color="primary"
              text
              v-bind="attrs"
              v-on="on"
            >
              Help
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in dropMenu"
              :key="index"
              @click="handleHelpOption(item.value)"
            >
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <v-btn
        class="ma-md-2"
        small
        icon
        fab
        @click="
          $vuetify.theme.dark = !$vuetify.theme.dark;
          setDarkMode($vuetify.theme.dark);
        "
      >
        <v-icon color="secondary">mdi-weather-sunny</v-icon>
      </v-btn>

      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="ma-md-2" small icon fab to="/help" v-bind="attrs" v-on="on">
            <v-icon color="secondary">mdi-information</v-icon>
          </v-btn>
        </template>
        <span>Contact Us</span>
      </v-tooltip> -->

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="ma-md-2"
            small
            icon
            fab
            to="/settings"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="secondary">settings</v-icon>
          </v-btn>
        </template>
        <span>Settings</span>
      </v-tooltip>

      <v-btn
        v-show="
          [
            'Reports',
            'Team and Members',
            'Recording',
            'Message Templates',
            'Lists & Contacts',
            'Dashboard',
            'CRM',
            'Automation',
            'Custom Status',
            'DNC',
          ].includes($router.currentRoute.name)
        "
        class="ma-md-2"
        small
        icon
        fab
        :href="watchVideoTutorials"
        target="_blank"
      >
        <v-icon color="secondary">play_circle_filled</v-icon>
      </v-btn>

      <!-- v-show=" !['Pipeline'].includes($router.currentRoute.name) " -->
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            small
            icon
            fab
            class="ma-md-2"
            :disabled="reloading"
            v-bind="attrs"
            @click="refresh"
            v-on="on"
          >
            <v-icon color="secondary">refresh</v-icon>
          </v-btn>
        </template>
        <span>Refresh</span>
      </v-tooltip>
    </v-app-bar>

    <v-content class="inverted">
      <v-card
        v-if="$router.currentRoute.name != 'Login' && showExpiry"
        class="mx-7 my-2 px-5 py-3 d-block d-sm-flex justify-space-between elevation-2 customBorderRadius"
        two-line
      >
        <div class="d-flex align-center">
          <v-btn color="primarygrad" fab small>
            <v-icon color="white">mdi-currency-inr</v-icon>
          </v-btn>
          <p class="mb-0 mx-3">
            Your organization's subscription
            <span v-if="expiryOver != true">is expiring soon</span>
            <span v-else>has ended</span>
            . Kindly renew to continue using GoDial.
          </p>
        </div>

        <div class="d-flex flex-row-reverse">
          <v-btn
            color="primarygrad"
            style="border-radius: 8px;"
            @click="$router.push({ name: 'Subscribe' })"
          >
            Renew
          </v-btn>
        </div>
      </v-card>

      <div tile flat class="pa-0 ma-0 pb-15">
        <router-view />
      </div>

      <v-dialog v-model="loading" hide-overlay persistent width="300">
        <v-card color="primarygrad" dark>
          <v-card-text>
            Please stand by
            <v-progress-linear indeterminate color="white" class="mb-0" />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-content>

    <!-- Dialer FAB - Available on all pages when logged in -->
    <DialerFab
      v-if="
        $store.getters.user &&
          !$store.state.skipLogin &&
          $router.currentRoute.name !== 'login' &&
          $router.currentRoute.name !== 'Verify Email'
      "
      :show-auto-dialer="$router.currentRoute.name === 'CRM'"
    />

    <!-- Call Popup Container - Shows active call popups in bottom-right -->
    <!-- Now handles BOTH outgoing AND incoming calls as floating popups -->
    <CallPopupContainer
      v-if="
        $store.getters.user &&
          !$store.state.skipLogin &&
          $router.currentRoute.name !== 'login' &&
          $router.currentRoute.name !== 'Verify Email'
      "
    />

    <!-- Global Audio Element for Calls (used by auto-dialer and all outgoing calls) -->
    <audio
      id="remote-audio"
      ref="remoteAudio"
      autoplay
      playsinline
      webkit-playsinline
      x-webkit-airplay="allow"
      preload="auto"
      style="display: none;"
    ></audio>

    <!-- Incoming Call Dialog - DISABLED: Now using CallPopup instead for consistent UI -->
    <!-- <IncomingCallDialog /> -->
  </v-app>
</template>

<script>
import moment from "moment-timezone";
import fb from "./js/firebase";
import featureControl from "./js/featureControl";
import { mapGetters } from "vuex";
import DialerFab from "./components/DialerFab.vue";
import IncomingCallDialog from "./components/IncomingCallDialog.vue";
import CallPopupContainer from "./components/CallPopupContainer.vue";

export default {
  name: "App",
  components: {
    DialerFab,
    IncomingCallDialog,
    CallPopupContainer,
  },

  props: {
    source: String,
  },

  data: () => ({
    dialog: false,
    reloading: false,
    drawer: null,
    expiryOver: false,
    title: "",
    SubPage: false,
    previewImage: "",
    watchVideoTutorials: "",
    clarityIdentified: false,
    dropMenu: [
      {
        title: "Whatsapp",
        value: "whatsapp",
      },
      {
        title: "Phone",
        value: "phone",
      },
      {
        title: "Email",
        value: "email",
      },
    ],
  }),

  computed: {
    loading() {
      return this.$store.state.loading;
    },
    ...mapGetters(["ENDPOINT", "teams", "selectedTeam", "companyDetails"]),
    user() {
      return this.$store.getters.user;
    },
    surveyLink() {
      return this.companyDetails.country === "India" ? "/survey-in" : "/survey";
    },
    items() {
      var expiry = moment(this.companyDetails.plan.expiryDate);
      var now = moment();
      var isExpired = now.isAfter(expiry);

      // Use store getter for PBX lock status (checks plan type AND expiry)
      var isPbxLocked = this.$store.getters.isPbxLocked;

      return [
        { icon: "mdi-laptop", text: "Dashboard", link: "/home", visible: true },
        {
          icon: "mdi-television-guide",
          text: "CRM",
          link: "/lists",
          visible: true,
        },
        {
          icon: "mdi-account-multiple-outline",
          text: "Team & Members",
          link: "/users",
          visible: true,
        },
        {
          icon: "mdi-whatsapp",
          text: "Whatsapp",
          beta: true,
          visible: true,
          children: [
            {
              icon: isExpired ? "mdi-lock" : "mdi-message-text-outline",
              text: "Inbox",
              link: "/inbox",
              visible: true,
              disabled: isExpired,
            },
            {
              icon: isExpired ? "mdi-lock" : "mdi-google-circles-extended",
              text: "Templates",
              link: "/whatsapp-templates",
              visible: true,
              disabled: isExpired,
            },
            {
              icon: isExpired ? "mdi-lock" : "mdi-memory",
              text: "Automation",
              link: "/whatsapp-automation",
              visible: true,
              disabled: isExpired,
            },
            {
              icon: isExpired ? "mdi-lock" : "mdi-cast",
              text: "Broadcast",
              link: "/broadcast",
              visible: true,
              disabled: isExpired,
            },
            {
              icon: isExpired ? "mdi-lock" : "mdi-chart-arc",
              text: "Reports",
              link: "/whatsapp-reports",
              visible: true,
              disabled: isExpired,
            },
            {
              icon: "settings",
              text: "Settings",
              link: "/whatsapp-settings",
              visible: true,
            },
          ],
        },
        // {
        //   icon: "mdi-phone-voip",
        //   text: "Cloud Telephony",
        //   link: "/cloudtelephony",
        //   visible: this.companyDetails.defaultDialer != 'Telecmi',
        // },
        {
          icon: "mdi-chart-bar",
          text: "Reports and Analytics",
          visible: true,
          children: [
            {
              icon: "mdi-chart-line",
              text: "Master",
              link: "/reports-v2",
              visible: true,
            },
            {
              icon: "mdi-shape-plus",
              text: "Summary",
              link: "/summary",
              visible: true,
            },
            {
              icon: "mdi-chart-box-outline",
              text: "Disposition",
              link: "/disposition-report",
              visible: true,
            },
            {
              icon: " mdi-account-check",
              text: "Productivity",
              link: "/productivity-v2",
              visible: true,
            },
            {
              icon: " mdi-star-outline",
              text: "Leaderboard",
              link: "/game",
              visible: true,
            },
            {
              icon: " mdi-fingerprint",
              text: "Attendance",
              link: "/productivity-attendance",
              visible: true,
            },
            {
              icon: "mdi-chart-pie",
              text: "Performance",
              link: "/performance-v2",
              visible: true,
            },
            {
              icon: " mdi-pen",
              text: "Audit",
              link: "/Audit",
              visible: true,
            },
          ],
        },
        {
          icon: "mdi-tools",
          text: "Tools",
          visible: true,
          children: [
            {
              icon: "mdi-memory",
              text: "Automation",
              link: "/automation",
              visible: true,
            },
            {
              icon: "mdi-stocking",
              text: "Pipeline",
              link: "/stages",
              visible: featureControl.enabled("pipeline"),
            },
            {
              icon: "mdi-clipboard-outline",
              text: "Tasks",
              link: "/tasks",
              visible: true,
            },
            {
              icon: "mdi-pencil-box-outline",
              text: "GoCollect",
              link: "/form",
              visible: true,
            },
            {
              icon: "mdi-cube-outline",
              text: "Products",
              link: "/products",
              visible: true,
            },
            {
              icon: "mdi-lightbulb-outline",
              text: "Web Dialer",
              link: "/webdialer",
              visible: true,
              beta: true,
            },
          ],
        },
        {
          icon: "mdi-lightbulb-outline",
          text: "Marketing",
          visible: true,
          children: [
            // {
            //   icon: "language",
            //   text: "Go Pages",
            //   link: "/gopages",
            //   visible: true,
            // },
            {
              icon: "mdi-rocket-launch-outline",
              text: "Go Pages",
              link: "/gopagesv2",
              visible: true,
            },
            {
              icon: "mdi-microphone-outline",
              text: "Voice Broadcast",
              link: this.surveyLink,
              visible: this.companyDetails.country !== "India",
              beta: true,
            },
            // {
            //   icon: "mdi-microphone-outline",
            //   text: "Voice Broadcast",
            //   link: "/survey-in",
            //   visible: true,
            //   beta: true,
            // },
            {
              icon: "mdi-clipboard-outline",
              text: "Web Form",
              link: "/integrate_form",
              visible: true,
              beta: true,
            },
          ],
        },
        {
          icon: isPbxLocked ? "mdi-lock" : "mdi-phone-voip",
          text: "GoDial PBX",
          link: "/pbx",
          visible: true,
          beta: true,
        },
        // {
        //   icon: "mdi-lightbulb-outline",
        //   text: "Advanced",
        //   children: [
        //     {
        //       icon: "dialpad",
        //       text: "Web Dialer",
        //       link: "/webdialer",
        //       visible: true,
        //       beta: true,
        //     },
        //   ],
        // },

        // {
        //   icon: "mdi-cellphone-link",
        //   text: "Team App",
        //   link: "/apps",
        //   visible: true,
        // },

        {
          icon: "mdi-credit-card",
          text: "Subscribe",
          link: "/payments",
          visible: true,
        },
      ];
    },
    companyDetails() {
      return this.$store.getters.companyDetails;
    },

    teams() {
      return this.$store.getters.teams;
    },

    selectedTeam: {
      get(v) {
        return this.$store.getters.selectedTeam;
      },
      set(v) {
        this.$store.commit("setSelectedTeam", v);
      },
    },

    showExpiry() {
      if (this.$router.currentRoute.name == "Login") {
        return false;
      } else {
        try {
          var self = this;
          var company = this.$store.getters.companyDetails;
          var expiry = moment(company.plan.expiryDate);
          var now = moment();
          var planName = company.plan.name;

          var expiryBefore2Days = expiry.clone().subtract(2, "day");
          if (now.isAfter(expiry)) {
            self.expiryOver = true;
          } else {
            self.expiryOver = false;
          }

          if (planName == "GoDial Premium" && now.isAfter(expiry)) {
            return true;
          } else if (now.isAfter(expiryBefore2Days)) {
            return true;
          } else {
            return false;
          }
        } catch (e) {
          console.log(e);
          return false;
        }
      }
    },
  },

  watch: {
    drawer(newVal) {
      // Emit drawer state for PayWallCard positioning
      this.$root.$emit("drawer-changed", newVal);
    },
    "$store.state.user": {
      handler(newUser, oldUser) {
        // Initialize dialer when user logs in
        if (newUser) {
          this.$store.dispatch("dialer/initializeDialer");
          // Fetch PBX data when user logs in
          if (newUser.companyId) {
            this.$store.dispatch("fetchPbxData", newUser.companyId);
          }
        } else if (oldUser && !newUser) {
          // Clear PBX data when user logs out
          this.$store.dispatch("removePbxData");
        }
      },
      immediate: false,
    },
    companyDetails(value) {
      if (value !== undefined || value !== null) {
        this.computeLogo();
        this.maybeIdentifyClarity();
      }
    },
    user() {
      this.maybeIdentifyClarity();
    },

    $route(to) {
      this.title = to.name;
      this.SubPage = to.meta.subPage;

      this.watchVideoTutorials = "";

      if (to.name == "Reports") {
        this.watchVideoTutorials = "https://youtu.be/7Ry1wHihIMU";
      } else if (to.name == "Team and Members") {
        this.watchVideoTutorials = "https://youtu.be/IGKA_uaJqJU";
      } else if (to.name == "CRM") {
        this.watchVideoTutorials = "https://youtu.be/eKGePmpeAc0";
      } else if (to.name == "Automation") {
        this.watchVideoTutorials = "https://youtu.be/mJY9WJcSE9I";
      } else if (to.name == "Team App") {
        this.watchVideoTutorials = "https://youtu.be/WikjR6Cy5F4";
      } else if (to.name == "Custom Status") {
        this.watchVideoTutorials = "https://youtu.be/bAP5x8P7BGM";
      } else if (to.name == "DNC") {
        this.watchVideoTutorials = "https://youtu.be/XighqViPADE";
      } else if (to.name == "Recording") {
        this.watchVideoTutorials = "https://youtu.be/V1lNB9Nsrds";
      } else if (to.name == "Message Templates") {
        this.watchVideoTutorials = "https://youtu.be/w93olITYTlE";
      } else if (to.name == "Dashboard") {
        this.watchVideoTutorials = "https://youtu.be/UKKVCPVKOws";
      } else {
        this.watchVideoTutorials = "";
      }

      // try {
      //   window.Intercom("update");
      // } catch (e) {
      //   console.log(e);
      // }
    },
  },

  created() {
    var self = this;
    if (self.$router.currentRoute.name === "Reports") {
      this.watchVideoTutorials = "https://youtu.be/7Ry1wHihIMU";
    } else if (self.$router.currentRoute.name == "Team and Members") {
      this.watchVideoTutorials = "https://youtu.be/IGKA_uaJqJU";
    } else if (self.$router.currentRoute.name == "Recording") {
      this.watchVideoTutorials = "https://youtu.be/V1lNB9Nsrds";
    } else if (self.$router.currentRoute.name === "Lists & Contacts") {
      this.watchVideoTutorials = "https://youtu.be/eKGePmpeAc0";
    } else if (self.$router.currentRoute.name == "Message Templates") {
      this.watchVideoTutorials = "https://youtu.be/w93olITYTlE";
    } else if (self.$router.currentRoute.name === "Team App") {
      this.watchVideoTutorials = "https://youtu.be/WikjR6Cy5F4";
    } else if (self.$router.currentRoute.name === "Custom Status") {
      this.watchVideoTutorials = "https://youtu.be/bAP5x8P7BGM";
    } else if (self.$router.currentRoute.name === "DNC") {
      this.watchVideoTutorials = "https://youtu.be/XighqViPADE";
    }

    if (self.$store.state.user) {
      fb.init(self.$store.state, self);
    }

    console.log("companyDetails: ", this.companyDetails);
    console.log("going to identify clarity");
    this.maybeIdentifyClarity();
  },

  mounted() {
    // home screen app logo
    this.computeLogo();

    // Initialize dialer state and fetch PBX data if user is logged in (on page refresh)
    if (this.$store.state.user) {
      console.log("[App] User already logged in, initializing...");
      this.$store.dispatch("dialer/initializeDialer");

      // Fetch fresh PBX data from API on page refresh/reload
      // This ensures we always have the latest PBX configuration
      if (this.$store.state.user.companyId) {
        console.log("[App] Fetching fresh PBX data on page mount");
        this.$store.dispatch("fetchPbxData", this.$store.state.user.companyId);
      }
    }

    // Emit initial drawer state for PayWallCard
    this.$nextTick(() => {
      this.$root.$emit("drawer-changed", this.drawer);
    });

    // // Forcefully stay on /integration/googleSheetSync
    // const currentPath = window.location.pathname;
    // if (currentPath !== '/integration/googleSheetSync') {
    //   window.location.pathname = '/integration/googleSheetSync';
    //   return;
    // }

    // // Now process the code normally
    // let code = new URLSearchParams(window.location.search).get('code');

    // if (!code && window.location.hash.includes('code=')) {
    //   const hashParams = new URLSearchParams(window.location.hash.split('?')[1]);
    //   code = hashParams.get('code');
    // }

    // if (code) {
    //   this.authCode = code;
    //   this.sheetChooser = true;
    // }

    const url = new URL(window.location.href);
    const code = url.searchParams.get("code");
    const accountsServer = url.searchParams.get("accounts-server");
    const location = url.searchParams.get("location");
    const pathname = window.location.pathname || "";

    if (code) {
      // Detect Zoho OAuth callback. Zoho redirects to /zohoauth and appends
      // `accounts-server` and `location` query params. The code itself also
      // starts with the client prefix "1000." for Zoho.
      const isZohoCallback =
        accountsServer !== null ||
        location !== null ||
        pathname.indexOf("zohoauth") !== -1 ||
        (typeof code === "string" && code.startsWith("1000."));

      let cleanUrl;
      if (isZohoCallback) {
        // Preserve all query params (code, state, accounts-server, location...)
        cleanUrl = `${window.location.origin}/#/integration/zoho${url.search}`;
      } else {
        // Build a clean URL for Google Sheet Sync callback
        cleanUrl = `${
          window.location.origin
        }/#/integration/googleSheetSync?code=${encodeURIComponent(code)}`;
      }

      // Redirect the user to the clean URL
      window.location.href = cleanUrl;
      return; // Stop further execution for this mount
    }
  },

  methods: {
    maybeIdentifyClarity() {
      console.log("maybeIdentifyClarity");
      try {
        if (this.clarityIdentified) return;
        var u = this.user;
        var c = this.companyDetails;
        if (!u || !c) return;
        if (
          typeof window !== "undefined" &&
          typeof window.clarity === "function"
        ) {
          var userId = u.email || u.username;
          var props = {};

          // Build props object with only non-null values
          if (u.email) props.email = u.email;
          if (u.name) props.name = u.name;
          if (u.username) props.username = u.username;
          if (c.name) props.companyName = c.name;
          if (u.companyId || c.id) props.companyId = u.companyId || c.id;
          if (u.role) props.role = u.role;

          console.log("props: ", props);
          window.clarity("identify", String(userId), props);
          this.clarityIdentified = true;
        }
      } catch (e) {
        // Swallow errors to avoid impacting app
        console.log(e);
      }
    },
    handleHelpOption(option) {
      switch (option) {
        case "whatsapp":
          window.open("https://wa.me/7044406666", "_blank"); // Replace with your WhatsApp link
          break;
        case "phone":
          window.location.href = "tel:+9170444 06666"; // Replace with your phone number
          break;
        case "email":
          window.location.href = "mailto:support@godial.cc"; // Replace with your email address
          break;
        default:
          console.log("Invalid option");
      }
    },
    isMobile() {
      if (window.innerWidth <= 760) {
        return true;
      } else {
        return false;
      }
    },
    routeName() {
      if (
        typeof this.$router.currentRoute.query != "undefined" &&
        typeof this.$router.currentRoute.query.topic == "undefined"
      ) {
        var name = this.$router.currentRoute.name;
        if (name === "ReportsV2") return "Reports";
        if (name === "Productivity V2") return "Productivity";
        if (name === "Performance Report V2") return "Performance Report";
        if (name === "GoPagesV2Editor") return "Go Pages Editor";
        if (name === "GoPagesV2Analytics")
          return this.$route.query.pageName || "Landing Page Analyti 111cs";
        return name;
      } else if (
        typeof this.$router.currentRoute.query != "undefined" &&
        this.$router.currentRoute.query.topic == "teams"
      ) {
        return "Team Management";
      } else if (
        typeof this.$router.currentRoute.query != "undefined" &&
        this.$router.currentRoute.query.topic == "assignments"
      ) {
        return "List Management";
      } else {
        return "";
      }
    },
    setDarkMode(v) {
      this.$store.commit("setDarkMode", v);
    },
    computeLogo() {
      if (this.companyDetails) {
        if (this.companyDetails.logo) {
          return (this.previewImage = `${this.$store.state.ENDPOINT}/storages/get/${this.companyDetails.logo}?access_token=${this.$store.getters.user.token}`);
        } else {
          return (this.previewImage = require("@/assets/logo.png"));
        }
      }
    },

    // refresh() {
    //   var currentRoute = this.$router.currentRoute.path;

    //   if (currentRoute == "/home")
    //     {this.$router.replace("/organization");}
    //   else
    //     {this.$router.replace("/home");}

    //   this.$nextTick(()=>{this.$router.replace(currentRoute)});
    // },

    refresh() {
      const self = this;
      self.reloading = true;

      var currentRoute = self.$route.fullPath;

      if (currentRoute == "/load") {
        self.$router.replace(
          "/home",
          function() {
            self.reloading = false;
          },
          function() {
            self.reloading = false;
          },
        );
      } else {
        self.$router.replace(
          "/load",
          function() {
            self.$nextTick(() => {
              self.$router.replace(currentRoute);
              self.reloading = false;
            });
          },
          function() {
            self.reloading = false;
          },
        );

        if (currentRoute == "/whatsapp-settings" || currentRoute == "/inbox") {
          self.$store.dispatch("getCompanyDetails", {
            companyId: self.$store.getters.user.companyId,
          });
        }
      }
    },

    logout() {
      //this.$store.dispatch("logout");
      const self = this;

      // Clear localStorage FIRST before any state changes
      const clearAndReload = () => {
        window.localStorage.clear();
        // Small delay to ensure localStorage is cleared before reload
        setTimeout(() => {
          window.location.reload();
        }, 100);
      };

      this.$http
        .post(this.$store.state.ENDPOINT + "/accounts/logout")
        .then(() => {
          self.$store.commit("setAllUsers", null);
          self.$store.commit("setUser", false);
          self.$store.commit("setTeams", null);
          self.$store.commit("setCompany", null);
          self.$store.commit("clearPbxData");
          fb.logout();
          clearAndReload();
        })
        .catch(() => {
          self.$store.commit("setAllUsers", null);
          self.$store.commit("setUser", false);
          self.$store.commit("setTeams", null);
          self.$store.commit("setCompany", null);
          clearAndReload();
        });
    },

    sideNavUpdate() {
      this.$emit("sideNavUpdate");
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500&display=swap");

html,
body {
  font-family: "Roboto", sans-serif;
}

#app {
  font-family: "Roboto", sans-serif;
}

.primarygrad {
  background-image: linear-gradient(to right, #37cf37, #37cf37);
}

.primarygrad.theme--light {
  background-image: linear-gradient(to right, #37cf37, #37cf37);
}

.primarygrad.theme--dark {
  background-image: linear-gradient(to right, #37cf37, #37cf37);
}

.infograd {
  background-image: linear-gradient(to right, #3ed1f3, #068fff);
}

.errorgrad {
  background-image: linear-gradient(to right, #f14968, #ff0303);
}

.notifygrad {
  background-image: linear-gradient(to right, #fc944f, #ed5b12);
}

.secondarygrad.theme--light {
  background-image: linear-gradient(to bottom, #ffffff, #ffffff);
}

.secondarygrad.theme--dark {
  background-image: linear-gradient(to bottom, #3b3b3b, #242424c4);
}

.bluegrad {
  background-image: linear-gradient(to top right, #190b97, #006efde8);
}

.thumb {
  background: #9cc134 !important;
}

.back.theme--light {
  background: #ecf4d9 !important;
}

.back.theme--dark {
  background: #3f4e1d31 !important;
}

.vti__input {
  color: inherit;
}

.custom {
  margin-top: 11px;
  margin-right: 30px;
}

.beta-chip {
  font-size: 9px !important;
  height: 16px !important;
  padding: 0 4px !important;
  font-weight: 600;
}

.v-application .rounded {
  border-radius: 12px !important;
}

.v-navigation-drawer .v-list-item,
.v-list-group {
  overflow: visible;
  /* Change this as needed */
}

.text-cap {
  text-transform: capitalize !important;
}

@media (min-width: 1200px) {
  .recordPadding {
    padding-left: 30%;
    padding-right: 30%;
  }
}

/* Landscape tablets and medium desktops */
@media (min-width: 992px) and (max-width: 1199px) {
  .recordPadding {
    padding-left: 30%;
    padding-right: 30%;
  }
}

/* Portrait tablets and small desktops */
@media (min-width: 768px) and (max-width: 991px) {
  .recordPadding {
    padding-left: 20%;
    padding-right: 20%;
  }
}

/* Landscape phones and portrait tablets */
@media (max-width: 767px) {
  .recordPadding {
    padding-left: 1%;
    padding-right: 1%;
  }
}

/* Portrait phones and smaller */
@media (max-width: 480px) {
  .recordPadding {
    padding-left: 1%;
    padding-right: 1%;
  }
}

/* ========================================
   DARK THEME - TEXT COLOR OVERRIDES
   ======================================== */

/* Blue-black text in dark theme */
.theme--dark .blue-black,
.theme--dark [style*="color:#30475A"],
.theme--dark [style*="color: #30475A"] {
  color: #ffffff !important;
}

/* Grey text adjustments for dark theme */
.theme--dark [style*="color: grey"],
.theme--dark [style*="color:grey"] {
  color: #b0b0b0 !important;
}

/* Ensure container backgrounds are dark */
.theme--dark .v-application {
  background: #121212 !important;
}

.theme--dark .v-main {
  background: #121212 !important;
}

.theme--dark .v-content {
  background: #121212 !important;
}

/* Navigation drawer dark theme */
.theme--dark .v-navigation-drawer {
  background: #1e1e1e !important;
}

/* App bar / toolbar dark theme */
.theme--dark .v-toolbar,
.theme--dark .v-toolbar.inverted,
.v-toolbar.theme--dark.inverted {
  box-shadow: none !important;
}

/* Team selector in navigation drawer */
.team-selector-text {
  color: #ffffff !important;
}

.theme--dark .team-selector .v-input__slot {
  background: #2d2d2d !important;
}

.theme--dark .team-selector .v-icon {
  color: #ffffff !important;
}
</style>
